import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Integrations = () => {
  return (
    <EmptyPage
      title="Integrations"
      description="Connect with external services, APIs, and third-party tools to enhance your real estate workflow and data management."
      icon="🔗"
    />
  );
};

export default Integrations;
